import * as React from 'react';
import { ExpertChangeRequestsContainer } from '../../containers';

const ExpertChangeRequestsPage = () => <ExpertChangeRequestsContainer />;

export default ExpertChangeRequestsPage;
